import { useCallback } from 'react';
import { nanoid } from 'nanoid';
import { usePanelOpenListener } from "../PanelEvent.js";
import LayoutUtils from "./LayoutUtils.js";
import usePanelRegistration from "./usePanelRegistration.js";
/**
 * Register a panel that will be opened when one of the `supportedTypes` objects is triggered.
 */
export function useDashboardPanel(_ref) {
  var dashboardProps = _ref.dashboardProps,
    componentName = _ref.componentName,
    component = _ref.component,
    supportedTypes = _ref.supportedTypes,
    hydrate = _ref.hydrate,
    dehydrate = _ref.dehydrate;
  var id = dashboardProps.id,
    layout = dashboardProps.layout,
    registerComponent = dashboardProps.registerComponent;
  var handlePanelOpen = useCallback(_ref2 => {
    var dragEvent = _ref2.dragEvent,
      _ref2$panelId = _ref2.panelId,
      panelId = _ref2$panelId === void 0 ? nanoid() : _ref2$panelId,
      widget = _ref2.widget;
    var name = widget.name,
      type = widget.type;
    var isSupportedType = type != null && (Array.isArray(supportedTypes) && supportedTypes.includes(type) || type === supportedTypes);
    if (!isSupportedType) {
      // Only want to listen for your custom variable types
      return;
    }
    var props = {
      localDashboardId: id,
      metadata: widget
    };
    if (hydrate != null) {
      props = hydrate(props, id);
    }
    var config = {
      type: 'react-component',
      component: componentName,
      props,
      title: name !== null && name !== void 0 ? name : undefined,
      id: panelId
    };
    var root = layout.root;
    LayoutUtils.openComponent({
      root,
      config,
      dragEvent
    });
  }, [componentName, hydrate, id, layout, supportedTypes]);

  /**
   * Register our custom component type so the layout know hows to open it
   */
  usePanelRegistration(registerComponent, component, hydrate, dehydrate);

  /**
   * Listen for panel open events so we know when to open a panel
   */
  usePanelOpenListener(layout.eventHub, handlePanelOpen);
}
export default useDashboardPanel;
//# sourceMappingURL=useDashboardPanel.js.map